<template>
    <div class="mainWrap">

        <div class="mainBar" :style="{
            // backgroundImage: 'url(' + (winW > 1920 ? bannerBg2x : bannerBg) + ')',
            backgroundImage: 'url(' + (bannerBg) + ')',
        }">

            <headerWX class="headerWX"></headerWX>
            <!-- <noticeWX></noticeWX> -->

            <div class="hallWrap">
                <div class="top">
                    <img src="@/assets/imgs/Exchange/head_title.png" alt="">
                </div>
                <!-- 用户信息 -->
                <!-- <div class="describe">
                    <div>
                        大区：<div>{{ userInfo.gameArea == '' ? '暂无' : userInfo.gameArea }}</div>
                    </div>
                    <div>
                        游戏昵称：<div>{{ userInfo.usernick == '' ? '暂无' : userInfo.usernick }}</div>
                    </div>
                </div> -->
                <!-- 兑换按钮 -->
                <div class="center">
                    <div class="center_boby">
                        <div class="server redeemCode">
                            <div>选择大区：</div>
                            <el-select v-model="serverId" placeholder="请选择大区">
                                <el-option :label="item.serverName" :value="item.serverId" v-for="item in serverList"
                                    :key="item.serverId" />
                            </el-select>
                        </div>
                        <div class="redeemCode">
                            <div>兑换码：</div> <input type="text" v-model="center" placeholder="请输入兑换码">
                        </div>
                        <div class="center_btn" @click="submit()"></div>
                    </div>

                </div>
                <!-- 提示信息 -->
                <div class="bottom">
                    <div>
                        <p>1.每种兑换码每个账号仅限使用一次。</p>
                        <p>2.兑换成功后请登录游戏，打开礼物箱领取道具奖励。</p>
                        <p>3.通过礼包获取幸运钥匙、好运符后请于官网账户中查收。</p>
                        <p>4.兑换码逾期不补，获取后请及时兑换。</p>
                    </div>
                </div>
            </div>
        </div>
        <footerWX></footerWX>

        <!-- 二次确认弹窗 -->
        <div id="mask" v-if="ispopUp">
            <div
                style="position: fixed; top: 13%;left: 35%;border-radius: 10px; width: 30vw; height: 70vh;min-width: 600px; padding: 5px;background: linear-gradient(#D7B7FF, #F9F8FF); z-index: 9999;">
                <popUp @ispopUp="TzpopUp" propShow=3 :DBF_goShop=DBF_goShop></popUp>
            </div>
        </div>

        <div id="mask" class="code" ref="Code" v-if="iscode">

        </div>
    </div>
</template>

<script>
// import menuWX from '@/components/Menu'
import axios from "axios";
import Cookies from "js-cookie";
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
import popUp from "@/components/pop_up";
// import noticeWX from '@/views/home/notice'
import { getServerList } from '@/api/public.js'
import { giftExchangeApi } from '@/api/Exchange/index'

export default {
    name: 'SixOneEight',
    components: {
        // menuWX,
        // noticeWX,
        headerWX,
        footerWX,
        popUp,
    },
    data() {
        return {
            bannerBg: require("@/assets/imgs/Exchange/bannerBg.png"),
            // 每日任务获取倒计时判断
            dailyTask: 60,
            ispopUp: false,
            iscode: false,

            DBF_goShop: '',
            userInfo: {
                verifyInfo: {},
                vipInfo: {},
                wallteInfo: {},
            },            // 用户信息
            center: '',
            serverId: '',
            serverList: []
        }
    },
    created() {
        // this.getHallFameData()
        this.init()
    },
    mounted() {
        document.documentElement.scrollTop = 0
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))



    },
    methods: {

        // 兑换码提交

        async submit() {
            if (this.center == '') {
                this.$message.error('请输入兑换码')
                return
            } else if (this.serverId == '') {
                this.$message.error('请选择大区')
                return
            }
            else {
                this.iscode = true
                setTimeout(() => {
                    _dx.Captcha(this.$refs.Code, {
                        // appId, 在控制台应用管理或应用配置模块获取
                        appId: "bbd5e18516aefff8be9a93ad86ae2f4a",
                        apiServer: 'https://dx-api.dingxiang-inc.com',
                        style: 'oneclick',
                        // apiServer域名地址在控制台页面->无感验证->应用管页面左上角获取，必须填写完整包括https://。
                        success: token => {
                            this.iscode = false
                            // 获取验证码token，用于后端校验，注意获取token若是sl开头的字符串，则是前端网络不通生成的降级token,请检查前端网络及apiServer地址。
                            // console.log(token);
                            this.getCode(token)
                        }
                    });
                }, 0);
            }
        },

        async getCode(token) {
            await giftExchangeApi({
                code: this.center,
                serverId: this.serverId,
                source: this.userInfo.source,
                userId: Cookies.get('cwsl_userId'),      // userId
                ticket: token,
                platForm: 'web',
            }).then((res) => {
                if (res.data.state == 200) {
                    // console.log(res.data);
                    this.center = ''
                    this.$message.success(res.data.message)

                } else {
                    this.center = ''
                    this.$message.error(res.data.message)
                    // ({
                    //     type: 'error',
                    //     message: res.data.message,
                    //     duration: 3000
                    // })
                }
            }).catch(err => {
                this.$message.error(err.message)
            })
        },

        async init() {
            await getServerList({})
                .then(({ data }) => {
                    if (data.state == 200) {
                        this.serverList = data.data.list
                    }
                })
        }
    }
}
</script>

<style lang="less" scoped>
.headerWX {
    margin: 0;

    // /deep/ .header {
    //     background: transparent;
    // }
}

#mask {
    width: 100% !important;
    height: 100%;
    // opacity: 0.6;
    background-color: rgba(0, 0, 0, 0.8);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 999;
}

.code {
    display: flex;
    align-items: center;
    justify-content: center;
}
/deep/.dx_captcha_oneclick_bar{
    width: 200px;
}

.mainWrap {

    min-width: 1200px;
    min-height: 100vh;
    background: #81b549;
    // background-image: url('../../assets/imgs/DragonBoatFestival/bannerBg.png');

    .mainBar {
        max-width: 2000px;
        margin: auto;
        color: #333333;
        background-size: 100%;
        min-height: 100vh;
        overflow: hidden;
        background-size: 100% 100%;
        background-repeat: no-repeat;

    }
}

.hallWrap {
    // height: 1131px;
    min-height: 100vh;
    width: 70%;
    margin: auto;
    margin-top: 150px;
    position: relative;

    .top {
        text-align: center;
    }

    .describe {
        width: 50%;
        height: 50px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        // margin: 20px 0;

        div {
            width: 50%;
            font-size: 20px;
            display: flex;
            align-items: center;

            div {
                margin-left: 10px;
                font-weight: bold;
                font-family: MingLiU, PingFang SC;
                font-size: 25px;
                color: #FFFFFF;
                font-style: normal;
                text-transform: none;
                -webkit-text-stroke: 1px #EA0000;
                padding-bottom: 5px;
                white-space: nowrap;

            }
        }

    }

    .center {
        width: 60%;
        margin: auto;
        margin-bottom: 50px;

        .center_boby {
            height: 450px;
            background-image: url(../../assets/imgs/Exchange/exchange.png);
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            top: -35px;

            .server {
                margin-top: 50px !important;

                .el-select {
                    width: 325px;

                    /deep/.el-input__inner {
                        background-color: rgba(255, 255, 255, 0.2);
                        height: 54px;
                        font-size: 28px;
                        color: #000;


                        &::placeholder {
                            color: #757575;
                            /* 设置 placeholder 文字颜色为红色 */
                        }
                    }

                    /deep/.el-input.is-focus .el-input__inner {
                        border-color: #000;
                    }
                }
            }

            .redeemCode {
                >div:nth-child(1) {
                    width: 150px;
                    text-align: right;
                }

                margin-top: 15px;
                height: 65px;

                div {
                    display: inline-block;
                    height: 80px;
                    color: #fff;
                    font-size: 30px;
                }

                input {
                    height: 50px;
                    width: 300px;
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #FFFFFF;
                    font-size: 30px;
                    padding-left: 20px;
                }
            }

            .center_btn {
                width: 199px;
                height: 90px;
                background-image: url(../../assets/imgs/Exchange/btn.png);
                background-size: 100% 100%;
            }
        }



    }

    .bottom {
        width: 80%;
        margin: auto;
        margin-bottom: 200px;
        height: 300px;
        position: relative;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(135, 135, 135, 0.25);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #734E00;

        div {
            height: 270px;
            width: 75%;
            margin: auto;
            position: absolute;
            bottom: 0;
            left: 90px;

            p {
                font-size: 20px;
                margin-top: 20px;
                line-height: 30px;
                color: #734E00;

            }

        }
    }
}
</style>